/**
 * TermsConditions
 * @returns ReactElement
 */

import { activityInfo } from '@/types';
import { stringBrChange } from '@/utils/common';
import { useFm } from '@web3/base-hooks';

type TermsConditionsProp = {
  data: activityInfo | undefined;
};

export function TermsConditions(props: TermsConditionsProp) {
  const { data } = props;
  const fm = useFm();

  return (
    <>
      {data?.activityDisclaimer ? (
        <div className="terms-conditions-wrap bg-area mt-6 p-6 main">
          <h2 className="text-2xl font-semibold">{fm('termsAndConditions')}</h2>
          <div
            className="mt-6 text-gray1"
            dangerouslySetInnerHTML={{
              __html: stringBrChange(data?.activityDisclaimer || ''),
            }}
          ></div>
        </div>
      ) : null}
    </>
  );
}
